import Link from 'next/link';
import Image from 'next/image';

export default function Footer() {
  return (
    <footer className="bg-rc-bg border-t border-rc-border mt-8">
      {/* Multi-device Banner */}
      <div className="bg-gradient-to-r from-[#1a0a00] to-[#0d1a2e] py-10 px-4">
        <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <p className="text-gray-400 text-sm">Experience</p>
            <h2 className="text-white text-3xl font-black leading-tight">
              Premium Live Streaming
              <br />
              on Any Device
            </h2>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-rc-orange flex items-center justify-center">
                <span className="text-white font-black text-sm">RC</span>
              </div>
              <div>
                <p className="text-white text-sm font-semibold">Download The App Now</p>
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-0.5">
                    <span className="text-yellow-400 text-xs font-bold">4.2</span>
                    <svg className="w-3 h-3 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  </div>
                  <span className="text-gray-400 text-xs">10M+ Downloads</span>
                </div>
              </div>
            </div>
            <div className="flex gap-3">
              <a href="https://fancode.onelink.me/tTJR/DWebAndroid" target="_blank" rel="noopener noreferrer">
                <Image
                  src="https://images.fancode.com/skillup-uploads/fc-web/playstore-logo-new.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvZmMtd2ViL3BsYXlzdG9yZS1sb2dvLW5ldy5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsiZml0IjoiY292ZXIiLCJ3aWR0aCI6MTI1LCJoZWlnaHQiOjM2fSwid2VicCI6eyJxdWFsaXR5Ijo2MCwibG9zc2xlc3MiOmZhbHNlfX0sIm91dHB1dEZvcm1hdCI6IndlYnAifQ=="
                  alt="Google Play Store"
                  width={125}
                  height={36}
                  unoptimized />
                
              </a>
              <a href="https://fancode.onelink.me/tTJR/DWebiOS" target="_blank" rel="noopener noreferrer">
                <Image
                  src="https://images.fancode.com/skillup-uploads/fc-web/appstore-logo-new.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvZmMtd2ViL2FwcHN0b3JlLWxvZ28tbmV3LnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJmaXQiOiJjb3ZlciIsIndpZHRoIjoxMTIsImhlaWdodCI6MzZ9LCJ3ZWJwIjp7InF1YWxpdHkiOjYwLCJsb3NzbGVzcyI6ZmFsc2V9fSwib3V0cHV0Rm9ybWF0Ijoid2VicCJ9"
                  alt="Apple App Store"
                  width={112}
                  height={36}
                  unoptimized />
                
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="py-10 px-4 max-w-[1440px] mx-auto">
        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="text-gray-500 text-xs font-bold uppercase tracking-widest mb-4">SPORTS</h4>
            <ul className="space-y-2">
              {['Cricket', 'Football', 'Formula 1', 'Tennis', 'MotoGP', 'Golf', 'Motorsports']?.map((s) =>
              <li key={s}>
                  <Link href={`/${s?.toLowerCase()?.replace(' ', '')}`} className="text-gray-400 text-sm hover:text-white transition-colors">{s}</Link>
                </li>
              )}
            </ul>
          </div>
          <div>
            <h4 className="text-gray-500 text-xs font-bold uppercase tracking-widest mb-4">SCHEDULE</h4>
            <ul className="space-y-2">
              {['Cricket Schedule', 'Football Schedule', 'Formula 1 Schedule', 'MotoGP Schedule']?.map((s) =>
              <li key={s}>
                  <Link href="/schedule" className="text-gray-400 text-sm hover:text-white transition-colors">{s}</Link>
                </li>
              )}
            </ul>
          </div>
          <div>
            <h4 className="text-gray-500 text-xs font-bold uppercase tracking-widest mb-4">FEATURED TOURS</h4>
            <ul className="space-y-2">
              {[
              'Roshn Saudi League 2026-2027',
              'India Tour of Afghanistan, 2026',
              'LALIGA 2026-27',
              'EFL Championship 2026-27']?.
              map((t) =>
              <li key={t}>
                  <Link href="/tours" className="text-gray-400 text-sm hover:text-white transition-colors">{t}</Link>
                </li>
              )}
            </ul>
          </div>
          <div>
            <h4 className="text-gray-500 text-xs font-bold uppercase tracking-widest mb-4">OTHER LINKS</h4>
            <ul className="space-y-2">
              {[
              { label: 'About', href: '/about' },
              { label: 'Careers', href: '/careers' },
              { label: 'Help Desk', href: '/help' },
              { label: 'T&Cs', href: '/terms' },
              { label: 'Privacy', href: '/privacy' },
              { label: 'Subscribe', href: '/subscribe' },
              { label: 'Report Vulnerability', href: '/report' }]?.
              map((l) =>
              <li key={l?.label}>
                  <Link href={l?.href} className="text-gray-400 text-sm hover:text-white transition-colors">{l?.label}</Link>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="border-t border-rc-border pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3">
              <span className="text-2xl font-black">
                <span className="text-rc-orange">RED</span>
                <span className="text-white">CARD</span>
              </span>
              <span className="text-gray-600 text-xs">by DreamSports</span>
            </div>
            <div>
              <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-2">EXPERIENCE THE APP</p>
              <div className="flex gap-2">
                <a href="https://fancode.onelink.me/tTJR/DWebAndroid" target="_blank" rel="noopener noreferrer">
                  <Image
                    src="https://images.fancode.com/skillup-uploads/fc-web/playstore-logo-new.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvZmMtd2ViL3BsYXlzdG9yZS1sb2dvLW5ldy5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsiZml0IjoiY292ZXIiLCJ3aWR0aCI6MTI1LCJoZWlnaHQiOjM2fSwid2VicCI6eyJxdWFsaXR5Ijo2MCwibG9zc2xlc3MiOmZhbHNlfX0sIm91dHB1dEZvcm1hdCI6IndlYnAifQ=="
                    alt="Google Play"
                    width={100}
                    height={30}
                    unoptimized />
                  
                </a>
                <a href="https://fancode.onelink.me/tTJR/DWebiOS" target="_blank" rel="noopener noreferrer">
                  <Image
                    src="https://images.fancode.com/skillup-uploads/fc-web/appstore-logo-new.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvZmMtd2ViL2FwcHN0b3JlLWxvZ28tbmV3LnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJmaXQiOiJjb3ZlciIsIndpZHRoIjoxMTIsImhlaWdodCI6MzZ9LCJ3ZWJwIjp7InF1YWxpdHkiOjYwLCJsb3NzbGVzcyI6ZmFsc2V9fSwib3V0cHV0Rm9ybWF0Ijoid2VicCJ9"
                    alt="App Store"
                    width={90}
                    height={30}
                    unoptimized />
                  
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <div>
              <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-2">HELPDESK</p>
              <a
                href="https://wa.me/917021862182"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white text-sm font-semibold hover:text-rc-orange transition-colors">
                
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                CHAT WITH US
              </a>
            </div>
            <div>
              <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-2">KEEP IN TOUCH</p>
              <div className="flex gap-3">
                {[
                { href: 'https://www.facebook.com/Fancode/', src: 'https://images.fancode.com/skillup-uploads/fc-web/Facebook@3x.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvZmMtd2ViL0ZhY2Vib29rQDN4LnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJmaXQiOiJjb3ZlciIsIndpZHRoIjozMiwiaGVpZ2h0IjozMn0sIndlYnAiOnsicXVhbGl0eSI6NjAsImxvc3NsZXNzIjpmYWxzZX19LCJvdXRwdXRGb3JtYXQiOiJ3ZWJwIn0=', alt: 'Facebook' },
                { href: 'https://www.instagram.com/fancode/', src: 'https://images.fancode.com/skillup-uploads/fc-web/Instagram@3x.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvZmMtd2ViL0luc3RhZ3JhbUAzeC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsiZml0IjoiY292ZXIiLCJ3aWR0aCI6MzIsImhlaWdodCI6MzJ9LCJ3ZWJwIjp7InF1YWxpdHkiOjYwLCJsb3NzbGVzcyI6ZmFsc2V9fSwib3V0cHV0Rm9ybWF0Ijoid2VicCJ9', alt: 'Instagram' },
                { href: 'https://twitter.com/fancode', src: 'https://images.fancode.com/skillup-uploads/fc-web/X@3x.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvZmMtd2ViL1hAM3gucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7ImZpdCI6ImNvdmVyIiwid2lkdGgiOjMyLCJoZWlnaHQiOjMyfSwid2VicCI6eyJxdWFsaXR5Ijo2MCwibG9zc2xlc3MiOmZhbHNlfX0sIm91dHB1dEZvcm1hdCI6IndlYnAifQ==', alt: 'Twitter/X' },
                { href: 'https://www.youtube.com/FanCode', src: 'https://images.fancode.com/skillup-uploads/fc-web/Youtube.png?hash=eyJrZXkiOiJza2lsbHVwLXVwbG9hZHMvZmMtd2ViL1lvdXR1YmUucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7ImZpdCI6ImNvdmVyIiwid2lkdGgiOjMyLCJoZWlnaHQiOjMyfSwid2VicCI6eyJxdWFsaXR5Ijo2MCwibG9zc2xlc3MiOmZhbHNlfX0sIm91dHB1dEZvcm1hdCI6IndlYnAifQ==', alt: 'YouTube' }]?.
                map((social) =>
                <a key={social?.alt} href={social?.href} target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity">
                    <Image src={social?.src} alt={social?.alt} width={32} height={32} unoptimized />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Corporate Office */}
        <div className="mt-6 pt-6 border-t border-rc-border">
          <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-1">CORPORATE OFFICE</p>
          <p className="text-gray-500 text-xs">Ascent, 6th floor, Sudam Kalu Ahire Marg, Opposite GSK, Worli, Mumbai, Maharashtra 400030</p>
        </div>

        {/* About */}
        <div className="mt-6 pt-6 border-t border-rc-border">
          <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-2">ABOUT REDCARD</p>
          <p className="text-gray-600 text-xs leading-relaxed max-w-4xl">
            RedCard is India&apos;s premier destination for live sports streaming, match moments, and highlights. Trusted by over 3 crore sports fans, RedCard brings you seamless access to live matches, real-time scores, and instant replays from across the world of sports. Watch cricket, football, basketball, baseball, wrestling, badminton, and more—live and on demand. Stay updated with ball-by-ball scores, match analysis, video highlights, and the biggest moments from both Indian and international tournaments.
          </p>
          <p className="text-gray-600 text-xs mt-4">&copy;2024 RedCard, All Rights Reserved.</p>
        </div>
      </div>
    </footer>);

}